export enum TrainingLogsRoutes {
  CreateOne = 'create-one',
  DeleteOne = 'delete-one',
  UpdateOne = 'update-one',
  Search = 'search',
  Summarize = 'summarize',
}
